import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/shared/ui'
import { getLogo } from '@/modules/branding/brandingService'
import { isLightTheme } from '@/lib/theme'
import { useNavLinks } from '../hooks/useNavLinks'
import UserMenu from './UserMenu'

export default function TopNav() {
  const { links, effectiveRole } = useNavLinks()
  const [logoUrl, setLogoUrl] = React.useState<string | null>(null)
  const topLinks = React.useMemo(() => {
    if (effectiveRole !== 'member') return links
    const order = ['/oportunidades', '/analise-cripto', '/visoes', '/chat', '/evolucoes']
    const byPath = new Map(links.map((it) => [it.to, it]))
    return order.map((path) => byPath.get(path)).filter(Boolean) as typeof links
  }, [links, effectiveRole])

  React.useEffect(() => {
    let cancelled = false
    async function update() {
      try { const url = await getLogo('home' as any, isLightTheme()); if (!cancelled) setLogoUrl(url) } catch { if (!cancelled) setLogoUrl(null) }
    }
    update()
    const el = document.documentElement
    const obs = new MutationObserver(() => { update() })
    try { obs.observe(el, { attributes: true, attributeFilter: ['class'] }) } catch {}
    return () => { cancelled = true; try { obs.disconnect() } catch {} }
  }, [])

  return (
    <header className="sticky top-0 z-30 w-full border-b border-[#121212] backdrop-blur supports-[backdrop-filter]:bg-background/70">
      <nav>
        <div className="mx-auto max-w-[1550px] px-6">
          <div className="grid grid-cols-[1fr,auto,1fr] items-center py-3 lg:py-4">
            <div className="hidden lg:flex items-center">
              {logoUrl && (
                <Link to="/" className="inline-flex items-center">
                  <img src={logoUrl} alt="logo" className="h-7 w-auto md:h-8 object-contain" />
                </Link>
              )}
            </div>
            <div className="flex justify-center" />
            <div className="hidden lg:flex items-center justify-end gap-6">
              <ul className="flex gap-8 text-sm">
                {topLinks.map((it, i) => (
                  <li key={i}>
                    <Link to={it.to} className="block text-foreground/70 duration-150 hover:text-foreground">
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="lg:border-l lg:pl-6">
                <UserMenu align="end" />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}
